/*********************************************************
 *                  Carrier vehicles Ctrl
 ********************************************************/


"use strict";

angular.module("manager")
	.controller("VehicleCtrl", [
		"$scope", "Utils", "$uibModal", "VehicleService", "toastr", "DTOptionsBuilder", "DTColumnBuilder", "$location", "$compile", "$sanitize",
		function ($scope, Utils, $uibModal, VehicleService, toastr, DTOptionsBuilder, DTColumnBuilder, $location, $compile, $sanitize) {

		/**
		 * INIT
		 */
		var deleteModal, importModal;

		$scope.data = {
			vehicles: [],
			selectedVehicle: {},
			availableEquipmentList: [],
			selectedEquipmentList: [],
			categoryList: ["BUS", "CAR", "MINIBUS"],
			editMode: false,
			importFile: {}
		};

		var columnList = [
			{
				value: "immat",
				name: "Immatriculation",
				columnFilterParams: {
					type: "text"
				}
			}, {
				value: "model",
				name: "Modèle",
				columnFilterParams: {
					type: "text"
				}
			}, {
				value: "brand",
				name: "Marque",
				columnFilterParams: {
					type: "text"
				}
			}, {
				value: "category",
				name: "Categorie",
				columnFilterParams: {
					type: "select",
					values: $scope.data.categoryList,
					"bSearchable": true // category
				}
			}, {
				value: "circulationDate",
				name: "Date de mise en circulation",
				columnFilterParams: null,
				renderWith: dateFormat
			}, {
				value: "seatingCapacity",
				name: "Assise",
				columnFilterParams: {
					type: "num"
				}
			}, {
				value: "standingCapacity",
				name: "Debout",
				columnFilterParams: {
					type: "num"
				}
			}, {
				value: "specialPlaceCapacity",
				name: "<span class=\"fa fa-wheelchair\"></span>",
				columnFilterParams: {
					type: "num"
				}
			}, {
				value: "vehicleEquipmentList",
				name: "Liste d'équipements",
				columnFilterParams: null,
				renderWith: equipmentRender
			}, {
				value: "actions",
				name: "",
				columnFilterParams: {
					type: "html"
				},
				renderWith: actionsHtml
			}];

		// Création du tableau
		$scope.dtOptions = DTOptionsBuilder
			.newOptions()
			.withOption("serverSide", true)
			.withOption("processing", true)
			.withOption("fnServerData", function (sSource, aoData, fnCallback) {
				VehicleService.getVehicleWithFilters(createObjectRequestFilter(aoData))
					.then((response) => {
						const data = response.data;
						fnCallback(data);
						$scope.data.serverResponse = data;
						$scope.data.vehicles = data.data;
					});
			})
			.withOption("fnFooterCallback", footerCallback)
			.withDisplayLength(10)
			.withOption("autoWidth", true)
			.withPaginationType("full_numbers")
			.withOption("createdRow", createdRow)
			.withColumnFilter({
				aoColumns: columnList.map( function(c ) { return c.columnFilterParams; })
			})
			.withBootstrap()
			.withBootstrapOptions({
				ColVis: {
					classes: {
						masterButton: "btn btn-default"
					}
				}
			});


		$scope.dtInstance = {};
		// faire un tableau des colonnes
		$scope.dtColumns = [];
		columnList.forEach(function (column) {
			var columnBuilder = DTColumnBuilder.newColumn(column.value).withTitle(column.name);
			if (column.renderWith != null) {
				columnBuilder.renderWith(column.renderWith);
			}
			$scope.dtColumns.push(columnBuilder);
		});

		/**
		 * Formatter les inputs en fonction de leur type de recherche
		 * @param footer
		 */
		function footerCallback(footer) {
			var indexInputNumberType = [];
			columnList.forEach(function (column, index) {
				if(column.columnFilterParams != null) {
					if(column.columnFilterParams.type === "num") {
						indexInputNumberType.push(index);
					}
				}
			});
			indexInputNumberType.forEach(function (index) {
				$(footer).find("th:eq(" + index + ") input").attr("type", "number");
			});
		}

		/**
		 * Compiler la ligne d'un véhicule pour rendre possible les intéractions
		 * @param row
		 * @param data
		 * @param dataIndex
		 */
		function createdRow(row, data, dataIndex) {
			// Recompiling so we can bind Angular directive to the DT
			$compile(angular.element(row).contents())($scope);
		}

		/**
		 * Rendre les actions possibles sur le vehicule
		 * @param data
		 * @param type
		 * @param full
		 * @param meta
		 * @returns {string}
		 */
		function actionsHtml(data, type, full, meta) {
			var actions = "<div class=\"btn-group\">";
			var editAction = "<a title=\"Editer les informations d'un véhicule\" " +
				"href=\"#/manager/vehicles/" + $sanitize(full.id) + "/edit\" " +
				"class=\"btn btn-primary\">" +
				"<span class=\"fa fa-pencil-alt\"></span>" +
				"</a>";

			var deleteAction = "<button title=\"Supprimer un véhicule\" " +
				"ng-click=\"openDeleteModal(" + $sanitize(full.id) + ")\" " +
				"class=\"btn btn-danger\">" +
				"<span class=\"fa fa-trash\"></span>" +
				"</button>";

			actions += editAction + deleteAction;

			actions += "</div>";
			return actions;
		}

		function equipmentRender(data, type, full) {
			var equipmentDisplay = "";
			full.vehicleEquipmentList.forEach(function (equipment, index) {
				equipmentDisplay += equipment.name;
				if (index < full.vehicleEquipmentList.length - 1) {
					equipmentDisplay += ", ";
				}
			});
			return equipmentDisplay;
		}

		function dateFormat(data, type, full) {
			return Utils.getJSDateFromLocale(full.circulationDate).toLocaleDateString();
		}

		/**
		 * Création d'un objet à retourner à la plateforme pour prendre en compte les filtres
		 *
		 * @param aoData
		 * @returns {{draw, columns: Array, order: {}, start, length, search}}
		 */
		function createObjectRequestFilter(aoData) {
			var resultToSend = {
				draw: aoData[0].value,
				columns: [],
				order: {},
				start: aoData[3].value,
				length: aoData[4].value,
				search: aoData[5].value.value
			};
			aoData[1].value.forEach(function (column) {
				if (column.data != undefined) {
					var columnInfo = {};
					columnInfo.name = column.data;
					columnInfo.search = column.search.value;
					// Add "type" information on a column
					var columnSource = columnList.find(function (c) { return c.value === column.data;});
					if (columnSource.columnFilterParams != null) {
						columnInfo.type = columnSource.columnFilterParams.type;
					}
					resultToSend.columns.push(columnInfo);
				}
			});

			aoData[2].value.forEach(function (order) {
				resultToSend.order.name = resultToSend.columns[order.column].name;
				resultToSend.order.dir = order.dir;
			});
			// Copie des filtres pour une éventuelle demande d'export CSV
			$scope.copyFilters = resultToSend;
			return resultToSend;
		}

		/**
		 * Remettre les filtres et la liste de vehicules à 0
		 */
		$scope.razFilters = function () {
			$("#table tfoot input").val("").change();
			$("#table tfoot select").val("").change();
			$("#table").DataTable().state.clear();
		};

		/**
		 * Récupérer les vehicules, éventuellement filtrés.
		 */
		$scope.getVehicles = function () {
			$("#table").DataTable().search("").draw();
		};

		/**
		 * Ouvrir la popup pour suppression d'un véhicule.
		 *
		 * @param vehicleId
		 */
		$scope.openDeleteModal = function (vehicleId) {
			var vehicle = $scope.data.vehicles.find(function (v) { return v.id === vehicleId;});
			$scope.data.selectedVehicle = vehicle;

			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		/**
		 * Ouvrir la popup d'import.
		 */
		$scope.openImportModal = function () {
			importModal = Utils.openModal($uibModal, "import.html", $scope);
		};

		/**
		 * Valide la suppression d'un vehicule.
		 *
		 * @param vehicleId
		 */
		$scope.deleteVehicle = function (vehicleId) {
			VehicleService.deleteVehicleById(vehicleId)
				.then(() => {
					toastr.success("Vehicule supprimé.");
					deleteModal.close();
					$scope.getVehicles();
					$scope.data.selectedVehicle = {};
				})
				.catch((error) => {
					toastr.error(Utils.makeErrorMessage(error.data, "Erreur lors de la suppression du véhicule."));
				});
		};
	}]
	);